const getters = {
    name(state) {
        if ('name' in state.fortnox) {
            return state.fortnox['name'];
        } 
        return null;
    },
    phone(state) {
        if ('phone' in state.fortnox) {
            return state.fortnox['phone'];
        } 
        return null;
    },
    organizationNumber(state) {
        if ('organizationNumber' in state.fortnox) {
            return state.fortnox['organizationNumber'];
        } 
        return null;
    },
    contactFirstName(state) {
        if ('contactFirstName' in state.fortnox) {
            return state.fortnox['contactFirstName'];
        } 
        return null;
    },
    contactLastName(state) {
        if ('contactLastName' in state.fortnox) {
            return state.fortnox['contactLastName'];
        } 
        return null;
    },
    city(state) {
        if ('city' in state.fortnox) {
            return state.fortnox['city'];
        } 
        return null;
    },
    webpage(state) {
        if ('webpage' in state.fortnox) {
            return state.fortnox['webpage'];
        } 
        return null;
    },
    email(state) {
        if ('email' in state.fortnox) {
            return state.fortnox['email'];
        } 
        return null;
    },
    databaseNumber(state) {
        if ('databaseNumber' in state.fortnox) {
            return state.fortnox['databaseNumber'];
        } 
        return null;
    }
}

export default getters;